/**
 * Valid email address regex, as defined by [RFC 5322](https://www.ietf.org/rfc/rfc5322.txt),]
 * modified for use in Username Identifiers for the Identity Providers page
 * which should work for 99.99% of email addresses.
 */
export const USERNAME_EMAIL_REGEX =
    // eslint-disable-next-line no-control-regex
    /^@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i;
